import { render, staticRenderFns } from "./EncargoCompGrid.vue?vue&type=template&id=47270be1&"
import script from "./EncargoCompGrid.vue?vue&type=script&lang=js&"
export * from "./EncargoCompGrid.vue?vue&type=script&lang=js&"
import style0 from "./EncargoCompGrid.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./EncargoCompGrid.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports